import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-ru-reservation-detail',
    templateUrl: './ru-reservation-detail.component.html',
    styleUrls: ['./ru-reservation-detail.component.css'],
    standalone: false
})
export class RuReservationDetailComponent implements OnInit {

	reservation: any;

	constructor(private dynamicDialogRef: DynamicDialogRef,
		private dynamicDialogConfig: DynamicDialogConfig,) { }

	ngOnInit(): void {
		if (this.dynamicDialogConfig.data) {

			// get the review
			this.reservation = this.dynamicDialogConfig.data.reservation;
		}
	}
}
